export type ProfileDTO = {
  first_name: string
  last_name: string
  email: string
  phone: string
  birth_date: string
  can_show_info: boolean
  national_id: string
  is_sejam_verified: boolean
  company_name: string | null
  company_national_id: string | number | null
  exchange_code: string
  faraboors_code: string
  legal_type: string
  is_profile_completed: boolean
  bankAccounts: UserBankAccountDTO
  referral_code?: string
}
export type UserDTO = {
  companyName: string | null
  companyNationalId: string | number | null
  userName: string
  userInitial: string
  firstName: string
  lastName: string
  nationalId: string
  phone: string
  email: string
  accountNumber: string
  isSejamVerified: boolean
  exchangeCode: string
  faraboorsCode: string
  legalType: string
  is_profile_completed: boolean
  bankAccounts: UserBankAccountDTO
  birth_date: string
  can_show_info: boolean
  referral_code?: string
}

export type AuthDTO = {
  refresh_token: string
  access_token: string
}
export type CommentDTO = {
  id: number
  content: string | null
  authorName: string
  authorLastName: string
  replyTo: number | null
  createdAt: string | null
  replies: CommentDTO[]
}
export type GiftDTO = {
  id: number
  amount: string | number
  code: string | number
}
export type TransactionDTO = {
  type: string
  date: string
  transactionAmount: string
  depositType: string
  cardNumber: string
  trackingCode: string
  status: boolean
}
export type ReportDTO = {
  title: string
  registrationDate: string
  campaignName: string
  attachmentCount: string
  description: string
}

export enum PlanStatusDTO {
  notStarted = 'notStarted',
  inProgress = 'inProgress',
  funded = 'funded',
  expired = 'expired',
  pending = 'pending',
  finish = 'finish',
}
export interface PdpInfoDTO {
  id: number
  title: string
  fixedProfit: number | string
  maxInvestment: number | string
  fundraising_spent_time: number | string
  minInvestment: number | string
  maxLegalInvestment: number | string
  minLegalInvestment: number | string
  maxRealInvestment: number | string
  minRealInvestment: number | string
  daysLeft: number
  isPrivate: number
  status: PlanStatusDTO

  guarantee: Guarantee
  investors: number

  providedFund: number

  showComments?: number
  addComments?: number
  duration?: string
  profitPerMonth?: string | number
  percent_per_month?: string | number
  percentPerMonth?: string | number
  industry?: string
  fundraiser?: string
  fundraiserName?: FundraiserName
  banners?: Banner[]
  banner?: Banner
  plan_phases?: PdpPhaseDTO[]
  plan_phase_title?: string
}
export interface PdpIntroductionDTO {
  fundraiserName: string
  persianConfirmedSymbol: string
  industry: string
  market: string
  city: string
  description: string
  benefits: string[]
  farabourseLink: string
  guarantees: Guarantee[]
}
export enum GuaranteeTypeDTO {
  performance = 'performance',
  property = 'property',
  bankPayment = 'bankPayment',
  fundPayment = 'fundPayment',
  security = 'security',
  gold = 'gold',
  thirdParty = 'thirdParty',
  auditorAcceptance = 'auditorAcceptance',
}
export interface Guarantee {
  title: string
  type: GuaranteeTypeDTO
  priority: number
  file: FileDTO
  logo: FileDTO
}

export interface Banner {
  id: string
  url: string
  extension: string
}

export interface PdpEvaluationDTO {
  evaluation: Evaluation
  fundraisingHistory: FundraisingHistory[]
  evaluationDoc: EvaluationDoc
}
export enum ChequeStatusDTO {
  hasBounced = 'hasBounced',
  hasAsGuarantee = 'hasAsGuarantee',
  notBounced = 'notBounced',
}
export interface Evaluation {
  id: number
  date: string
  annualIncomeEstimation: number
  annualCostEstimation: number
  members: MemberDTO[]
}

export interface MemberDTO {
  name: string
  jobTitle: string
  chequeStatus: ChequeStatusDTO
}

export interface FundraisingHistory {
  id: number
  title: string
  platform: string
  amount: number
  completionDate: string
  duration: string
  fixedProfit: number
}

export interface EvaluationDoc {
  id: number
  type: string
  file: FileDTO
}

export interface PdpInvestorDTO {
  id: number
  name: string
}

export interface PdpDocumentsDTO {
  documents: DocumentDTO[]
  farabourseLink: string
}
export enum DocumentTypeDTO {
  guarantee = 'guarantee',
  finance = 'finance',
  introduction = 'introduction',
  contract = 'contract',
}

export interface DocumentDTO {
  id: number
  type: DocumentTypeDTO
  file: FileDTO
}

export interface FileDTO {
  id: string
  url: string
}

export interface PdpProgressReportDTO {
  id: number
  createdAt: string
  title: string
  brief: string
  file: FileDTO
  status?: 'passed' | 'normal' | string
}

export interface PdpPhaseDTO {
  id: number
  title: string
  startDate: string
  startDateDesc: string
  status?: 'done' | 'in_progress' | 'pending' | 'next' | string
  isProfit?: boolean
}

export interface PlanDTO {
  id: number
  title: string
  industry: string
  fixedProfit: number | string
  maxInvestment: number | string
  minInvestment: number | string
  daysLeft: number
  isPrivate: number
  status: PlanStatusDTO
  guarantee?: Guarantee
  investors: number
  fundraiserName: FundraiserName
  providedFund: number
  banner: Banner
}

export interface FundraiserName {
  name: string
  logo: FileDTO
}
export interface UserPortfolioDTO {
  total_investments_amount: number
  total_received_profits: number
  investment_plans_count: number
}
export interface SummeryInvestmentsDTO {
  investors_count: number
  users_investments_sum: number
  received_profits_sum: number
}

export interface UserPlanDTO {
  id: number
  title: string
  status: PlanStatusDTO

  fundraiser_name: string
  fixed_profit: number
  profit_per_month?: number
  percent_per_month?: number
  banner?: Banner
  banners?: Banner[]
  investments_amount: number
  total_annual_profit?: number
  received_profit?: number
  remainder_profit?: number
  plan_phase?: PlanPhase
  plan_phases?: PdpPhaseDTO[]
  remainder_days?: number
  all_days?: number
  finish_date?: string
  farabourse_file?: Banner
}
export interface PlanPhase {
  all_count: number
  current_count: number
  title: string
}

export type ResultDTO<T> = {
  data: T
  links: Links
  meta: Meta
}

export type TransactionFilterType =
  | 'investment'
  | 'return'
  | 'refund'
  | 'profit'

export interface TransactionFilter {
  type: TransactionFilterType
  page: number
}
export interface UserTransactionDTO {
  id: number
  status: string
  type: string
  amount: number
  reference_id?: string | null
  plan_title: string
  created_at: string
  payment_method: PaymentMethod
  bank_account?: BankAccount | null
}

export interface PaymentMethod {
  id: number
  type: string
  type_name: string
}

export interface BankAccount {
  id: number
  card_number: string
  sheba_number: string
}

export interface Links {
  first: string
  last: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  prev: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  next: any
}

export interface Meta {
  current_page: number
  from: number
  last_page: number
  links: Link[]
  path: string
  per_page: number
  to: number
  total: number
}

export interface Link {
  url?: string | null
  label: string
  active: boolean
}

export interface TicketFilter {
  page: number
}

export interface UserTicketDTO {
  id: number
  title: string
  body: string
  status: string
  created_at: string
  plan: UserPlanDTO
  file: FileDTO
}

export interface UserTicketForm {
  plan_id: number
  file_id?: string
  title: string
  body: string
}

export interface UploadForm {
  file: File
}

export type UserBankAccountForm = {
  card_number?: string
  sheba_number?: string
}

export type UserShebaForm = {
  sheba_number?: string
}

export type UserBankAccountDTO = {
  card_number: string
  id: number
  is_default_account: number
  sheba_number: string
}

export type TSejamForm = {
  faraboors_code: string
}

export interface ErrorResponse {
  message: string
}
export type PaymentType = 'online' | 'gift' | 'receipt'
export type TransactionCheckoutForm = {
  plan_id: string | number
  payment_method_id?: string | number
  amount?: string | number
  gift_id?: string | number
  type: PaymentType
}
export type CheckGiftForm = {
  plan_id: string | number
  code?: string | number
}
export interface TransactionCallbackDTO {
  id: number
  status: string
  type: string
  amount: number
  reference_id: number | null
  plan_title: string
  created_at: string
  payment_method: PaymentMethod
  bank_account: UserBankAccountDTO
  is_gift: boolean
}
export interface TransactionDependenciesDTO {
  can_user_investment: boolean
  user_investment: number
  min_user_investment: number
  max_user_investment: number
  max_IPG_amount: number
  is_read_policy: boolean
  payment_methods: PaymentMethod[]
  remaining_amount: number
  max_plan_investment: number
}

export interface PaymentMethod {
  id: number
  type: string
  type_name: string
}

export type AdvantagesDTO = {
  investments_sum: number
  fundraising_spent_time_avg: number
  fundraiser_count: number
  success_plans_count: number
}

export type InvestRequestDTO = {
  company_name: string
  national_id: string
  registration_number?: string
  phone: string
  first_name?: string
  last_name?: string

  full_name?: string
  fundraising_purpose?: string
  fundraising_purpose_other?: string
  fundraising_amount?: string
  monthly_sales_estimate?: string
  able_to_provide_bank_guarantee?: boolean
  has_outstanding_debts?: boolean
  utm?: string
}
export type MetaDataParams = {
  slug?: string[]
  id: string
  locale: string
}
export type MetaDataProps = {
  params: MetaDataParams
  searchParams?: { [key: string]: string | string[] | undefined }
}

export interface PlanFilter {
  limit: number
  [key: string]: string | number
}
export type FAQDTO = {
  id: number
  question: string
  answer: string
}

export type UpdateProfile = {
  params: {
    nationalCode?: string
    birthDate?: string
  }
  response: UserDTO
}

export interface OverDraftForm {
  full_name: string
  mobile: string
  job_title: string
  establishment_year: number
  company: string
  company_work_area: string
  company_future_goals: string
  funding_goal: string
  competitor_evaluation: string
  next_month_sales_forecast: number
}

export interface ReferralFilter {
  page: number
}

export interface UserReferralDTO {
  id: number
  referral_code: string
  reward: number
  phone_number: string
  is_registered_in_wallgold: boolean
  is_reward_received: boolean
  created_at: string
}
export interface UserReferralStaticsDTO {
  total_award: number
  referral_count: number
  total_wallgold: number
  is_active_button: boolean
}
export interface UserTransactionRewardDTO {
  id: number
  title: string
  award: number
  amount: number
  pay_status: string
  type: string
  created_at: string
}
export interface UserTransactionRewardStaticsDTO {
  total_award: number
  total_pending: number
  total_paid: number
  transaction_count: number
  is_active_button: boolean
}

export * from './global'
